import React from "react";
import { ChevronDown } from "lucide-react";

import { cn } from "@/lib/utils";

export const Select = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, children, ...props }, ref) => (
  <div className={cn("relative", className)}>
    <select
      ref={ref}
      className={cn(
        "h-9 w-full appearance-none rounded-md pl-3 pr-8 text-sm cursor-pointer",
        "bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700",
        "text-slate-900 dark:text-slate-100",
        "focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500",
      )}
      {...props}
    >
      {children}
    </select>
    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
  </div>
));

Select.displayName = "Select";
